<template>
    <div>
        <header class="pb-3">
            <b-container>
                <b-row>
                    <b-col>
                        <router-link to="/"><img src="@/assets/thepaymentoption-logo-white.svg" class="logo mt-4"/></router-link>
                    </b-col>
                    <b-col class="text-right pt-5" sm="12" md="9">
                        <ul class="menu">
                            <router-link tag="li" exact-active-class="active" :to="{name: 'accounts', params: {code}}">
                                <i class="fas fa-credit-card mr-2"></i>Accounts
                            </router-link>
                            <li class="active"><i class="fas fa-messages mr-2"></i>Messages <span class="message-count" v-if="messages.length">({{ messages.length }})</span></li>
                            <router-link tag="li" exact-active-class="active" :to="{name: 'profile', params: {code}}">
                                <i class="fas fa-user mr-2"></i>Profile<i class="fas fa-exclamation-triangle ml-2" v-if="contactIssues.length" :title="contactIssues.join(', ')"></i>
                            </router-link>
                            <li @click="sessionLogout"><i class="fas fa-sign-out mr-2"></i>Logout</li>
                        </ul>
                    </b-col>
                </b-row>
            </b-container>
        </header>

        <b-container class="mt-5 pb-5 mb-5">
            <b-row>
                <b-col md="5" sm="12" class="mb-5">
                    <router-link tag="div" v-for="msg in messages" :to="{name: 'message', params: {id: msg.id}}" exact-active-class="active" class="account">
                        <div>
                            <p class="mb-0"><strong><i :class="isLetter(msg) ? 'fas fa-mailbox' : 'fas fa-envelope'" class="mr-2 msg-icon"></i>{{ msg.subject }}</strong></p>
                            <p class="mb-0 meta">{{ msg.created_at | moment('MM/DD/YYYY') }} &mdash; {{ isLetter(msg) ? 'Mailed to ' : '' }}{{msg.to}}</p>
                        </div>
                    </router-link>
                </b-col>
                <b-col>
                    <router-view/>
                </b-col>
            </b-row>
        </b-container>

        <footer class="pt-3 pb-2">
            <b-container>
                <copyright class="mt-3 mb-3"/>
            </b-container>
        </footer>
    </div>
</template>

<script>
    import Copyright from "../components/Copyright";
    import {mapActions} from "vuex";
    import {contactIssues} from '@/utils/contact';

    export default {
        name: "Messages",
        components: {Copyright},
        props: ['id', 'code'],
        data: function() {
            return {
                messages: [],
                contact: null
            }
        },
        computed: {
            contactIssues: function() {
                return contactIssues(this.contact);
            }
        },
        methods: {
            ...mapActions(['getContact', 'getMessages', 'logout']),
            isLetter: function(msg) {
                return typeof msg.type === 'string' && msg.type.indexOf('letter-') === 0;
            },
            sessionLogout: function() {
                this.logout(this.code).then(() => {
                    console.log('Session destroyed.');
                });
                this.$router.push({name: 'home'});
            }
        },
        mounted: function() {
            this.getMessages(this.code).then(accounts => {
                this.messages = accounts;
            }, err => {
                this.$router.push({name: 'home'});
                console.error(err);
            });

            this.getContact(this.code).then(contact => {
                this.contact = contact;
            }, err => {
                console.error(err);
            });
        }
    };
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    .meta {
        font-size: 0.9rem;
        color: grey;
    }

    .msg-icon {
        color: #9a9a9a;
        font-size: 0.85em;
    }

    .total {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .account {
        cursor: pointer;
        margin-bottom: 0.5rem;
        font-size: 0.9rem;


        &:hover {
            background-color: #f4f4f4 !important;
        }

        &.active {
            background-color: #f7f7f7 !important;

            > div {
                border-left: 16px solid $green;
            }
        }

        > div {
            border-left: 16px solid #eeeeee;
            padding: 0.3rem 1.3rem;
            border-radius: 0.25rem;
        }

        border-radius: 0.25rem;
        background-color: #f7f7f7;
    }

    header {
        .logo {
            max-width: 160px;
        }

        background: #3c3c5f;
        color: white;

        .menu {
            list-style: none;

            li {
                display: inline-block;
                margin-left: 1rem;
                padding: 0.2rem 1rem;
                border-radius: 1.5rem;
                cursor: pointer;

                &:hover {
                    background-color: rgba(255, 255, 255, 0.15);
                }

                &.active {
                    background-color: white !important;
                    color: #3c3c5f;
                }

                @media only screen and (max-width: 600px) {
                    padding: 0.5rem;
                    margin-left: 0.5rem;
                }
            }

            @media only screen and (max-width: 600px) {
                text-align: left;
                padding: 0;
            }
        }
    }

    footer {
        border-top: 1px solid $gray-300;
        padding: 2rem 0 0;
        margin-top: 2rem;

        .copyright {
            color: $gray-500 !important;
        }
    }

    .fa-exclamation-triangle {
        color: orangered;
    }

    .message-count {
        font-size: 0.9rem;
        opacity: 0.8;
    }
</style>
